import React from 'react';
import classNames from 'classnames/bind';

import {UserCenterActionBar} from './actionBar/userCenterActionBar';
import {UserGrid} from './userGrid/userGrid';
import {UserGridFilter} from './gridFilter/userGridFilter';
import {GetRequest} from '../../common/service/GetRequest';
import {ModalService, InlineNotification} from '@elixir/components';
import {PostRequest} from '../../common/service/PostRequest';
import {ActionConfirmationModal} from './actionConfirmation/actionConfirmationModal';
import {ClientType, UserType} from './enum';
import './userCenter.scss';

import Transition from 'react-transition-group/Transition';
import PropTypes from 'prop-types';

export class UserCenter extends React.Component {

    static contextTypes = {
        translator: PropTypes.func
    };

    constructor (props) {
        super(props);

        this.unfilteredUserList = [];

        this.state = {
            notification: false,
            notificationMessage: '',
            searchText: '',
            userType: [],
            pageSize: 0,
            startIndex: 0,
            userList: [],
            selection: [],
            selectAll: false,
            selectedAction: ''
        };

        this.gridRowStateHandler = this.gridRowStateHandler.bind(this);
    }

    componentDidMount () {
        this.loadUserList();
    }

    refreshUserList () {
        setTimeout(() => {
            this.loadUserList();
        }, 300);
    }

    loadUserList () {
        const userSessionListUrl = '/rest/UserSession/List';

        new GetRequest(userSessionListUrl).then(
            (result) => {
                const {
                    searchText,
                    userType
                } = this.state;

                this.unfilteredUserList = result.records;

                let filteredUserList = this.filterUserList(searchText, userType, this.unfilteredUserList);

                filteredUserList = _.uniqBy(filteredUserList, (user) => {
                    return user.sessionId;
                });

                filteredUserList = _.map(filteredUserList, (user) => {
                    user._id = user.sessionId;
                    return user;
                });

                this.setState({userList: filteredUserList})
            }
        );
    }

    filterUserList (searchText, userType, userList) {
        const result = _.filter(userList, (userItem) => {
            let matchName = true;
            let matchUsername = true;
            let matchUserType = true;

            if (searchText.length > 0) {
                matchName = userItem.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
                matchUsername = userItem.username.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
            }

            if (userType.length > 0) {
                matchUserType = userType.indexOf(userItem.userType) !== -1;
            }

            return (matchName || matchUsername) && matchUserType;
        });

        return result;
    }

    onGridFilterChange (newFilter) {
        const {
            searchText,
            userType
        } = newFilter;

        const filteredUserList = this.filterUserList(searchText, userType, this.unfilteredUserList);

        this.setState({
            searchText: newFilter.searchText,
            userType: newFilter.userType,
            userList: filteredUserList
        });
    }

    toggleSelection (newSelection) {
        this.setState({selection: newSelection});
    };

    toggleAll (selectAll, selection) {
        const newSelection = [];
        const {userList} = this.state;

        if (selectAll) {
            _.each(selection, (sessionId) => {
                const session = _.find(userList, {sessionId: sessionId});
                const isDisabled = this.isDisabled(session);

                if (!isDisabled) {
                    newSelection.push(sessionId);
                }
            });
        }

        this.setState({
            selectAll: selectAll,
            selection: newSelection
        });
    };

    onSelectAction (action) {
        this.setState({selectedAction: action});
        this.refreshUserList();
    }

    buildPluralizedTranslation (translationKey, arg1, arg2) {
        let translation = this.context.translator(translationKey);
        translation = translation.replace('{$1}', arg1);
        translation = translation.replace('{$2}', arg2);
        return translation;
    }

    showActionConfirmation (title, message, actionHandler) {
        const modal = ModalService.showSimpleDialog(
            ActionConfirmationModal,
            {
                onOk: () => modal.close(),
                onCancel: () => modal.dismiss(),
                id: 'popup',
                isOpen: true,
                title: title,
                message: message,
                actionHandler: actionHandler
            },
            {
                wide: false,
                popOverAlign: 'center'
            }
        );
    }

    onConfirmAction () {
        const {
            selection,
            selectedAction
        } = this.state;

        const isForceLogout = selectedAction.actionId === 'forceLogout';
        const isBroadcastMessage = selectedAction.actionId === 'broadcastMessage';

        const selectedUserCount = selection.length;
        const pluralizationString = selectedUserCount > 1 ? 's' : '';
        const forceLogoutTitle = this.context.translator('userCenter.modal.forceLogoutTitle');
        const forceLogoutMessage = this.buildPluralizedTranslation('userCenter.modal.forceLogoutMessage', selectedUserCount, pluralizationString);

        const broadcastMessageTitle = this.context.translator('userCenter.modal.broadcastMessageTitle');
        const broadcastMessage = this.buildPluralizedTranslation('userCenter.modal.broadcastMessage', selectedUserCount, pluralizationString);

        let title;
        let message;
        let callback;

        if (isForceLogout) {
            title = forceLogoutTitle;
            message = forceLogoutMessage;
            callback = this.onForceLogout.bind(this);
        }
        else if (isBroadcastMessage) {
            title = broadcastMessageTitle;
            message = broadcastMessage;
            callback = this.onBroadcastMessage.bind(this);
        }

        this.showActionConfirmation(title, message, callback);
    }

    onCancelAction () {
        this.setState({
            selectedAction: '',
            selection: []
        });
        this.refreshUserList();
    }

    onBroadcastMessage (message) {
        const url = 'rest/UserSession/broadcastMessage';
        let notificationMessage = this.context.translator('userCenter.modal.broadcastMessageSuccess');

        this.setState({
            selectedAction: '',
            selectAll: false,
            selection: []
        });

        const onSuccess = (result) => {
            const numberOfMessagesSent = parseInt(result[ 'numberOfMessagesSent' ]);

            notificationMessage = notificationMessage.replace('{$1}', numberOfMessagesSent);
            notificationMessage = notificationMessage.replace('{$2}', numberOfMessagesSent.length > 1 ? 's' : '');

            this.showNotification(notificationMessage);
        };

        this.makeRequest(url, message, onSuccess);
        this.refreshUserList();
    }

    onForceLogout (message) {
        const url = 'rest/UserSession/forceLogout';
        let notificationMessage = this.context.translator('userCenter.modal.forceLogoutMessageSuccess');

        this.setState({
            selectedAction: '',
            selectAll: false,
            selection: []
        });

        const onSuccess = (result) => {
            const numberOfUsersLoggedOut = parseInt(result[ 'numberOfUsersLoggedOut' ]);

            notificationMessage = notificationMessage.replace('{$1}', numberOfUsersLoggedOut);
            notificationMessage = notificationMessage.replace('{$2}', numberOfUsersLoggedOut.length > 1 ? 's' : '');

            this.showNotification(notificationMessage);
        };

        this.makeRequest(url, message, onSuccess);
        this.refreshUserList();
    }

    buildRequestUserSessionList (userList, selection, shouldUseExclusion) {
        const selectedUsers = _.filter(userList, (user) => {
            let result;
            if (shouldUseExclusion) {
                result = selection.indexOf(user.sessionId) === -1;
            }
            else {
                result = selection.indexOf(user.sessionId) !== -1;
            }
            return result;
        });

        return _.map(selectedUsers, user => user.sessionId);
    }

    makeRequest (url, message, onSuccess, onError) {
        const {
            userList,
            selection,
            searchText,
            userType
        } = this.state;

        const totalRecords = userList.length;
        const hasSearchString = searchText.length > 0;
        const hasUserTypeFilter = userType.length > 0;
        const shouldUseExclusion = selection.length > parseInt(totalRecords / 2);
        const shouldUseFilterAPI = hasSearchString || hasUserTypeFilter || shouldUseExclusion;
        const sessionIdParamList = this.buildRequestUserSessionList(userList, selection, shouldUseExclusion);

        let data;
        let requestUrl;

        if (shouldUseFilterAPI) {
            data = {
                nameOrUsername: searchText,
                userType: userType.length === 0 ? [ UserType.AGENCY_BROKERAGE, UserType.SERVICE, UserType.UNDERWRITER, UserType.SYSTEM ] : userType,
                message: message
            };

            if (shouldUseExclusion) {
                data[ 'excludedSessionIds' ] = sessionIdParamList;
            }
            else {
                data[ 'sessionIds' ] = sessionIdParamList;
            }

            requestUrl = new URL(`${url}ByFilter`, window.location.origin);
        }
        else {
            data = {
                message: message,
                sessionIds: sessionIdParamList
            };
            requestUrl = new URL(url, window.location.origin);
        }

        const request = new PostRequest();
        request.post(requestUrl, data).then(onSuccess, onError);
    }

    showNotification (message) {
        const notificationDelay = 5000;

        this.setState({
            notification: true,
            notificationMessage: message
        });

        setTimeout(() => {
            this.setState({
                notification: false,
                notificationMessage: ''
            });

        }, notificationDelay);
    }

    isDisabled (row) {
        const clientType = row.clientType;
        const isOperator = clientType === ClientType.OPERATOR;
        const isUmStudio = clientType === ClientType.UM_STUDIO;

        const selectedAction = this.state.selectedAction;
        const isForceLogout = selectedAction.actionId === 'forceLogout';
        const isBroadcastMessage = selectedAction.actionId === 'broadcastMessage';

        let isDisabled = false;

        if (isForceLogout) {
            isDisabled = isOperator
        }
        else if (isBroadcastMessage) {
            isDisabled = isOperator || isUmStudio
        }

        return isDisabled;
    }

    gridRowStateHandler (state, rowInfo) {
        const session = rowInfo.row;
        const isDisabled = this.isDisabled(session);

        return {
            className: isDisabled ? 'disabled' : ''
        };
    }

    render () {
        const {
            userList,
            searchText,
            userType,
            selectAll,
            selection,
            selectedAction,
            notification,
            notificationMessage
        } = this.state;

        const multiSelectMode = selectedAction !== '';

        const notificationTpl = (
            <Transition
                in={notification}
                timeout={500}
                unmountOnExit>
                {state => {
                    return <InlineNotification className={classNames('actionNotification', state)}
                                               type="success"
                                               message={notificationMessage}> </InlineNotification>
                }}
            </Transition>

        );

        return (
            <div className="userCenter">

                {notificationTpl}

                <UserCenterActionBar
                    multiSelectMode={multiSelectMode}
                    selectionCount={selection.length}
                    selectedAction={selectedAction}
                    onSelectAction={this.onSelectAction.bind(this)}
                    onTakeAction={this.onConfirmAction.bind(this)}
                    onCancelAction={this.onCancelAction.bind(this)}
                />

                <div className="userGridContainer">
                    <UserGridFilter
                        searchText={searchText}
                        userType={userType}
                        onFilterChange={this.onGridFilterChange.bind(this)}
                        onRefresh={this.loadUserList.bind(this)}
                    />

                    <UserGrid userList={userList}
                              selectAll={selectAll}
                              selection={selection}
                              isRowDisabled={this.gridRowStateHandler}
                              multiSelectMode={multiSelectMode}
                              toggleSelection={this.toggleSelection.bind(this)}
                              toggleAll={this.toggleAll.bind(this)}/>
                </div>
            </div>
        );
    }
}

